import { render, staticRenderFns } from "./Adminuser.vue?vue&type=template&id=222d50a4&scoped=true"
import script from "./Adminuser.vue?vue&type=script&lang=js"
export * from "./Adminuser.vue?vue&type=script&lang=js"
import style0 from "./Adminuser.vue?vue&type=style&index=0&id=222d50a4&prod&scoped=true&lang=css"
import style1 from "./Adminuser.vue?vue&type=style&index=1&id=222d50a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222d50a4",
  null
  
)

export default component.exports